<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :editTitle="'Edição de ' + typeText"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :readOnly="readOnly"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :totals="totals"
        :typeText="typeText"
        :modelType="modelType"
        :readOnly="readOnly"
        :modelNameSingular="modelNameSingular"
        :isEdit="isEdit"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: {},
      formErrors: [],
      extraData: null,
      originalEntry: null
    };
  },
  props: {
    entry: Object,
    totals: Object,
    typeText: {
      type: String,
      default: "Pagamento"
    },
    modelType: {
      type: String,
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(loadEntry) {
      this.loading = true;
      this.originalEntry = loadEntry;
      this.editableEntry = _.cloneDeep(this.originalEntry);
      this.error = null;
      this.$apollo
        .query({
          query: LOAD_PAYMENT_EXTRA_DATA_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.editableEntry.validations = response.data.accountContext.payment.validations;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.pageLoading = true;
        Object.assign(this.originalEntry, this.editableEntry);
        this.pageLoading = false;
        this.$refs.baseEdit.closeDialog();
        this.$emit("entry-updated", this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_PAYMENT_EXTRA_DATA_QUERY = gql `
  {
    accountContext {
      payment {
        validations
      }
    }
    globalContext {
      allGlobalPaymentMethods {
        id
        name
      }
      allInstallmentsIntervals {
        id
        description
        intervalInDays
      }
    }
  }
`;
</script>

<style scoped></style>
